import React from "react";
import { connect } from "react-redux";
import { flushPurchaseOrder } from "../../redux";
import { HubDialogWrapper } from "../HubDialogWrapper";
import CreatePurchaseOrderContent from "./CreatePurchaseOrderContent";

const name = "purchase-order-create";

const CreatePurchase = ({ _flushPurchaseOrder = () => {} }) => {
  const content = { _flushPurchaseOrder };
  return (
    <HubDialogWrapper maxWidth="sm" name={name}>
      <CreatePurchaseOrderContent {...content} />
    </HubDialogWrapper>
  );
};

const mapStateToProps = () => ({});
const mapDispatchToProps = {
  _flushPurchaseOrder: flushPurchaseOrder,
};
export const CreatePurchaseOrder = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreatePurchase);
